import { EmarsysAction, EmarsysStateType } from '@/data/context/actions/emarsys';

export const initialEmarsyState: EmarsysStateType = {
	isFetching: false,
	emarsysSearchTagData: null,
	emarsysCategoryTagData: null,
	emarsysPDPTagData: null,
	emarsysTYPTagData: null,
	emarsysPDPTagFinished: null,
	emarsysWidgetType: {
		additional: false,
		regular: false,
		count: -1,
		executed: false,
	},
	emarsysAdditionalReady: false,
	emarsysRegularReady: false,
	hdmEmarsysBundleItemsReady: false,
};

export const emarsysReducer = (
	state: EmarsysStateType,
	action: EmarsysAction
): EmarsysStateType => {
	switch (action.type) {
		case 'EMARSYS_SEARCH_TAG_DATA':
			return { ...state, emarsysSearchTagData: action.payload };
		case 'EMARSYS_CATEGORY_TAG_DATA':
			return { ...state, emarsysCategoryTagData: action.payload };
		case 'EMARSYS_PDP_TAG_DATA':
			return { ...state, emarsysPDPTagData: action.payload };
		case 'EMARSYS_TYP_TAG_DATA':
			return { ...state, emarsysTYPTagData: action.payload };
		case 'EMARSYS_PDP_TAG_FINISHED':
			return { ...state, emarsysPDPTagFinished: action.payload };
		case 'EMARSYS_WIDGETS_TYPES':
			return { ...state, emarsysWidgetType: action.payload };
		case 'EMARSYSCARRUSEL_ADDITIONAL_READY':
			return { ...state, emarsysAdditionalReady: action.payload };
		case 'EMARSYSCARRUSEL_REGULAR_READY':
			return { ...state, emarsysRegularReady: action.payload };
		case 'EMARSYSBUNDLE_ITEMS_READY':
			return { ...state, hdmEmarsysBundleItemsReady: action.payload };
		default:
			return state;
	}
};
